module.exports = __webpack_public_path__ + "img/guoqi.png";